export const cinematicMovieText = {
  JP: {
    textLines: [
      '宮古島の絶景と、旅の一瞬を',
      '映画のようなショートムービーに',
    ],
  },

  EN: {
    textLines: [
      'Capture Miyakoisland’s beautiful scenery',
      'and your travel moments in a cinematic short film',
    ],
  },

  中文: {
    textLines: [
      '将宫古岛的绝美风景和旅行瞬间',
      '拍成电影感的短片',
    ],
  },

  한국어: {
    textLines: [
      '미야코지마의 아름다운 풍경과 여행의 순간을',
      '영화 같은 숏무비로 남겨드립니다',
    ],
  },
};
